import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowRightIcon } from "@heroicons/react/24/outline";
import { PMDialog } from "./PMDialog";
import {
  nameToIcon,
  nameToPath,
  statCardStyles,
  translateNameToSubtitle,
  translateNameToTitle,
} from "./dashboardStatsUtils";

export const DashboardStatsDetailDialog = ({ open, onClose, stats }) => {
  const { t } = useTranslation();

  if (!stats?.length) return null;

  return (
    <PMDialog
      open={open}
      onClose={onClose}
      title="dashboard.stats.detail_title"
      size="xl"
      closeOnOutsideClick
    >
      <p className="mb-4 text-sm text-slate-600">{t("dashboard.stats.detail_intro")}</p>

      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
        {stats.map((stat, index) => {
          const style = statCardStyles[index % statCardStyles.length];
          const Icon = nameToIcon(stat.name);
          const title = translateNameToTitle(stat.name, t);
          const subtitle = translateNameToSubtitle(stat.name, t);

          return (
            <Link
              to={nameToPath(stat.name)}
              key={stat.name}
              onClick={onClose}
              className="group block"
            >
              <article
                className={`h-full rounded-2xl border px-4 py-4 shadow-sm transition hover:-translate-y-0.5 hover:shadow-md ${style.accent}`}
              >
                <div className="flex items-start justify-between gap-2">
                  <div
                    className={`flex h-9 w-9 items-center justify-center rounded-lg ${style.iconWrap}`}
                  >
                    <Icon className="h-5 w-5" />
                  </div>
                  <ArrowRightIcon
                    className={`mt-0.5 h-4 w-4 shrink-0 transition group-hover:translate-x-0.5 ${style.arrow}`}
                  />
                </div>

                <div className="mt-3">
                  <div
                    className={`text-[11px] font-semibold uppercase tracking-[0.18em] ${style.eyebrow}`}
                  >
                    {title}
                  </div>
                  <p className={`mt-0.5 text-sm leading-5 ${style.subtitle}`}>{subtitle}</p>
                  <div className={`mt-1 text-2xl font-semibold tracking-tight ${style.number}`}>
                    {stat.count}
                  </div>
                </div>
              </article>
            </Link>
          );
        })}
      </div>
    </PMDialog>
  );
};
